import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import UI_ACTIONS from '../../data/UiActionConstants';
import UiAction from '../../components/UiAction';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import ListingPageComponent from '../../components/ListingPageComponent.js';
import { getApi } from '../../api/endpoints.js';


const Index = (props) => {
  const navigate = useNavigate();
  const defaultHeaderConfig = { disableSort: false };

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Circle',
      attr: 'circle_name',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Addon',
      attr: 'addon_name',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Offer',
      attr: 'offer_name',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Start Date',
      attr: 'start_date',
    },
    {
      ...defaultHeaderConfig,
      label: 'End Date',
      attr: 'end_date',
    },
    {
      ...defaultHeaderConfig,
      label: 'Discount Amount',
      attr: 'discount_amount',
    },
    {
      ...defaultHeaderConfig,
      label: 'Discount Percentage',
      attr: 'discount_percentage',
    },
    {
      disableSort: true,
      label: 'Actions',
      value: (row) => {
        return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.update_scheme.name)}>
            <div style={{cursor: 'pointer'}} onClick={(e) => onEditClick(row.id) }>
              <FontAwesomeIcon icon={faEdit}/>
            </div>
          </UiAction>
        </div>
      }
    }
  ]

  const onNewClick = () => {
    navigate('/offer_addons/new');
  }

  const onEditClick = (id) => {
    navigate(`/offer_addons/${id}/edit`)
  }

  const tableHeaderActionsComponent = () => {
    return <React.Fragment>
      <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.create_scheme.name)}>
        <button className="s-btn me-2" style={{ width: "150px" }} onClick={onNewClick}>
          <span>Add New Offer Addon</span>
        </button>
      </UiAction>
    </React.Fragment>
  }

  return <ListingPageComponent
    key={PAGES.OfferAddonsListingPage.name}
    uiPage={uiManager.getUiPage(PAGES.OfferAddonsListingPage.name)}
    breadcrumbs={[{label: 'Home', url: '/dashboard'}, {label: 'Offer Addons List'}]}
    listingMutation={getApi('offerAddons')}
    className="offer-addon-listing-page"
    contentHeading="Offer Addons List - Results"
    headers={headers}
    recordsKey="offer_addons"
    tableHeaderActionsComponent={tableHeaderActionsComponent()}
    searchBy={['ID', "Circle", 'Addon', 'Offer']}
  />
}

export default Index;
